var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row gutter-sm" },
      [
        _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("levels")))
          ])
        ]),
        _vm._l(_vm.levels, function(level, index) {
          return _c("div", { key: level.id, staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("title"),
                      error: _vm.$v.levels.$each[index].title.$error
                    },
                    model: {
                      value: level.title,
                      callback: function($$v) {
                        _vm.$set(level, "title", $$v)
                      },
                      expression: "level.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("multiplication_base"),
                      type: "number"
                    },
                    model: {
                      value: level.multiplication_base,
                      callback: function($$v) {
                        _vm.$set(level, "multiplication_base", $$v)
                      },
                      expression: "level.multiplication_base"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("points_to_acquire"),
                      type: "number",
                      error: _vm.$v.levels.$each[index].points_to_acquire.$error
                    },
                    model: {
                      value: level.points_to_acquire,
                      callback: function($$v) {
                        _vm.$set(level, "points_to_acquire", $$v)
                      },
                      expression: "level.points_to_acquire"
                    }
                  })
                ],
                1
              )
            ])
          ])
        })
      ],
      2
    ),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3" },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "positive",
              label: _vm.$t("save"),
              icon: "far fa-save"
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }